/**
 * Get Marketers Use Case
 *
 * Business logic for fetching marketers list
 */

import {ReportsRepository} from '../repository/ReportsRepository';
import {Marketer} from '../models/report.model';

export class GetMarketersUseCase {
  constructor (private reportsRepository: ReportsRepository) {}

  async execute (): Promise<Marketer[]> {
    try {
      return await this.reportsRepository.getMarketers();
    } catch (error) {
      throw new Error(`Failed to get marketers: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}


